module.exports = __webpack_public_path__ + "img/IBM_logo 1.f81da88b.svg";